function accordionTypeOne($elm) {
    $($elm).find('.js-accordion-type-1').click(function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('is-active');
        $(this).toggleClass('active').next().slideToggle('fast');
    });
}

export default accordionTypeOne;